import { render, staticRenderFns } from "./CustomerConfig.vue?vue&type=template&id=39118b43&scoped=true"
import script from "./CustomerConfig.vue?vue&type=script&lang=js"
export * from "./CustomerConfig.vue?vue&type=script&lang=js"
import style0 from "./CustomerConfig.vue?vue&type=style&index=0&id=39118b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39118b43",
  null
  
)

export default component.exports